import AsideElementOptionsDev from "./AsideElementOptionsDev";

function AsideElementDev() {
  return <AsideElementOptionsDev />;
}

export default AsideElementDev;
